// extracted by mini-css-extract-plugin
export var caption = "author-module--caption--769d0";
export var container = "author-module--container--7248f";
export var photo = "author-module--photo--84327";